module.exports = __webpack_public_path__ + "img/enthusiastic.03dafb78.svg";